/* @flow strict */

import _ from 'lodash';

const validateDonations = (donations: [], scrollCb: (HTMLElement) => void): boolean => {
  const defaultNodeEl = {
    style: {}
  };

  const validItems = _.map(donations, (t: {}, i: number): boolean => {
    let isValid = true;

    const el = document.querySelector(`.DonationItem[data-id="${t.id}"]`);

    if (!el) {
      console.warn(
        `DonationItem is not defined id ${t.id}`
      );
      return true;
    }

    const name = el.querySelector(`input.form-control[id="name-DItem-${i}"]`);
    const nameVMsg = name.nextSibling || defaultNodeEl;

    const defAmount = el.querySelector(`input[id="prefilled_amount-DItem-${t.id}"]`);
    const amountVMsg = defAmount.parentNode.nextSibling || defaultNodeEl;

    const descr = el.querySelector(`#description-DItem-${i}`);
    const descrVMsg = descr.parentNode.querySelector('.vMsg') || defaultNodeEl;

    let invalidEl = null;

    if (!_.size(_.trim(t.name))) {
      name.classList.add('validationElement');
      nameVMsg.style.display = 'block';

      invalidEl = name;

      isValid = false;
    } else {
      name.classList.remove('validationElement');
      nameVMsg.style.display = 'none';
    }

    if (t.prefilled_amount < 200) {
      defAmount.classList.add('validationElement');
      amountVMsg.style.display = 'block';

      invalidEl = defAmount;

      isValid = false;
    }  else {
      defAmount.classList.remove('validationElement');
      amountVMsg.style.display = 'none';
    }

    if (_.size(_.trim(t.description)) > 512) {
      descr.classList.add('validationElement');
      descrVMsg.style.display = 'block';

      invalidEl = descr;

      isValid = false;
    } else {
      descr.classList.remove('validationElement');
      descrVMsg.style.display = 'none';
    }

    if (scrollCb) {
      scrollCb(invalidEl);
    }

    return isValid;
  });

  return !_.some(validItems, (i: {}): boolean => i === false);
};

export const validateDonationItem = (d: {}): void => {
  const el = document.querySelector(`.DonationItem[data-id="${d.id}"]`);
  const defaultNodeEl = {
    style: {}
  };

  if (!el) {
    console.warn(
      `DonationItem is not defined id ${d.id}`
    );
    return true;
  }

  const defAmount = el.querySelector('input[name="prefilled_amount"]');
  const amountVMsg = defAmount.parentNode.nextSibling || defaultNodeEl;

  if (d.prefilled_amount < 200) {
    defAmount.classList.add('validationElement');
    amountVMsg.style.display = 'block';
  } else {
    defAmount.classList.remove('validationElement');
    amountVMsg.style.display = 'none';
  }
};

export default validateDonations;
